module.exports = __webpack_public_path__ + "static/media/16.0f004b36.jpg";